var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"convey-date-picker d-flex align-items-center gap-3 border bg-white-custom pl-3",class:{
    dark: _vm.isDarkMode,
    light: !_vm.isDarkMode,
    blocked: _vm.block,
  }},[_c('b-icon',{attrs:{"icon":"calendar2-week-fill"}}),_c('b-input-group',[_c('b-input',{staticClass:"daterange-input pl-0 bg-transparent",attrs:{"type":"text","readonly":"","value":_vm.dateRange,"placeholder":_vm.placeholder}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }